import { memo } from 'react';

const Check = () => (
  <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g transform="translate(-169 -2945)">
      <circle cx="12" cy="12" r="12" transform="translate(169 2945)" />
      <path d="M251.579,2938.384l4.88,4.9,8.882-8.925" transform="translate(-77 18.369)" />
    </g>
  </svg>
);

export const CheckIcon = memo(Check);
